import React from 'react';

const StickyNoteIcon = ({
  width = '15',
  height = '15',
  fill = 'none',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill={fill}
    {...props}
  >
    <g opacity="0.4" clipPath="url(#clip0_356_822)">
      <path
        d="M8.89335 13.7334H2.20415C1.95187 13.7372 1.70836 13.6409 1.52682 13.4657C1.34529 13.2904 1.2405 13.0505 1.23535 12.7982V2.06861C1.2405 1.81635 1.34529 1.57638 1.52682 1.40115C1.70836 1.22591 1.95187 1.12965 2.20415 1.13341H12.8666C12.9919 1.13155 13.1165 1.15442 13.233 1.2007C13.3496 1.24698 13.4559 1.31577 13.5458 1.40313C13.6358 1.49049 13.7077 1.59473 13.7573 1.70987C13.807 1.82501 13.8335 1.94882 13.8354 2.07421V8.83341L8.89335 13.7334Z"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.89355 9.30397V13.7336L13.8356 8.83357H9.37795C9.31521 8.83246 9.25287 8.84377 9.19451 8.86684C9.13615 8.88991 9.08293 8.9243 9.03791 8.96801C8.99289 9.01173 8.95696 9.06392 8.93219 9.12158C8.90741 9.17923 8.89428 9.24122 8.89355 9.30397Z"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.69336 5.55225H8.89336"
        stroke="black"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_356_822">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0.535156 0.433594)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default StickyNoteIcon;
